import { render } from "./AppTextarea.vue?vue&type=template&id=cc2b536a&scoped=true&ts=true"
import script from "./AppTextarea.vue?vue&type=script&lang=ts"
export * from "./AppTextarea.vue?vue&type=script&lang=ts"

import "./AppTextarea.vue?vue&type=style&index=0&id=cc2b536a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2b536a"]])

export default __exports__